import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Button, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { SlackBuilderFE } from '../../SlackBuilderFE.js';
import { generateHex, ServerErrorSeverity } from '@nu-art/ts-common';
export class ATS_SlackMessageBuilder extends ComponentSync {
    testChannel = '_harel-errors';
    static screen = {
        name: 'Slack message tester',
        key: 'slack-message-tester',
        renderer: this,
        group: 'Frontend',
    };
    sendMessage = async () => {
        const feMessageBuilder = new SlackBuilderFE(this.testChannel);
        return feMessageBuilder
            .addBlocks(SlackBuilderFE.TextSectionWithTitle('*Test title*', 'this message sent from FE!'))
            .addBlocks(SlackBuilderFE.TextSectionWithTitle('*Ultra long message*', generateHex(5000)))
            .addBlocks(SlackBuilderFE.Divider())
            .addBlocks(SlackBuilderFE.TextSection(`${SlackBuilderFE.SeverityEmoji(ServerErrorSeverity.Debug)} more text`))
            .send();
    };
    render() {
        return _jsx(_Fragment, { children: _jsx(Button, { variant: 'primary', onClick: this.sendMessage, children: "send message" }) });
    }
}
//# sourceMappingURL=ATS_SlackMessageBuilder.js.map